import type { ComponentChildren } from "preact";
// See Design > UI, "Curator Studio assets". Value includes its unit; context states the period or denominator. A label may carry a SampleMark.
export function Metric({ label, value, context }: { label: ComponentChildren; value: ComponentChildren; context: ComponentChildren }) {
  return <div class="ui-metric"><span class="ui-metric__label">{label}</span><strong>{value}</strong><span class="ui-metric__context">{context}</span></div>;
}
